import { render } from "./PromRequestView.vue?vue&type=template&id=060005c8"
import script from "./PromRequestView.vue?vue&type=script&lang=js"
export * from "./PromRequestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__